import View from './View';

export { default as View, defaultRenderMenuItem } from './View';

export default View;
